import { render } from "./changePasswordComponent.vue?vue&type=template&id=1b7e1124&scoped=true"
import script from "./changePasswordComponent.vue?vue&type=script&lang=js"
export * from "./changePasswordComponent.vue?vue&type=script&lang=js"

import "./changePasswordComponent.vue?vue&type=style&index=0&id=1b7e1124&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7e1124"]])

export default __exports__